import { CircleAlertIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface Props {
  errorCount: number;
}

export const UnsavedChangesAlert = ({ errorCount }: Props) => {
  const { t } = useTranslation();

  return (
    <Alert variant="warning" className="gap-y-2">
      <CircleAlertIcon size={16} />
      <AlertTitle className="text-sm leading-5 font-semibold tracking-normal">
        {t('dialog.alerts.error', { 0: errorCount, count: errorCount })}
      </AlertTitle>
      <AlertDescription>{t('prompts.unsaved_changes.bannerBody')}</AlertDescription>
    </Alert>
  );
};
